import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import type { DealerStatus } from "@/types";

export function useDealerStatus() {
  const [status, setStatus] = useState<DealerStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get<DealerStatus>("/api/account/dealer-status")
      .then((res) => setStatus(res.data))
      .catch(() => setStatus(null))
      .finally(() => setLoading(false));
  }, []);

  const isApproved = status?.status === "Approved";
  const discountPercentage = status?.discountPercentage ?? 0;
  const minOrderAmount = status?.minOrderAmount ?? 0;
  const dealerGroupName = status?.dealerGroupName;

  return { status, loading, isApproved, discountPercentage, minOrderAmount, dealerGroupName };
}
